
const ServiceData = [
    {
        icon: "bi bi-palette",
        title: "Web Design",
        paragraph: "Creating visually appealing and functional websites for businesses and individuals.I've worked on Bootstrap, React, React Native,  Firebase and many more."
    },
    {
        icon: "bi bi-phone",
        title: "Mobile App Design",
        paragraph: "I'm proficient in interface design of mobile applications (Android and iOS). I've extensive portfolio of interface design.You will be able to benefit from this service after a few days."
    },
    {
        icon: "bi bi-code-slash",
        title: "Web Development",
        paragraph: "Building and maintaining dynamic, interactive websites that meet the unique needs of businesses and individuals.So if you need a perfect team, So contact me."
    },
    {
        icon: "bi bi-handbag",
        title: "mobile apps",
        paragraph: "I'm proficient in interface design of mobile applications (Android and iOS). I've extensive portfolio of interface design. Please visit portfolio section."
    },
    {
        icon: "bi bi-window-stack",
        title: "Risponsive Design",
        paragraph: "I understand the power of responsive websites. That’s why I design responsive websites that adapt to the size of mobile, tablet or desktop a user is using to view it."
    },
    {
        icon: "bi bi-chat-dots",
        title: "CONSULTATION",
        paragraph: "Contact me for a free consultation to start your IT business or if you need any help regarding software solutions. Feel free to contact me.I will be in touch."
    },
]

export default ServiceData;